import type { ModelBranchWorkTime } from '@app/api/Branches';
import type { WithActiveBranchId } from '@app/api/shared';

export enum WorkScheduleEndpoints {
  UpdateWorkSchedule = 'UpdateWorkSchedule',
  UpdateWorkBreak = 'UpdateWorkBreak',
  UpdateWorkSchedules = 'UpdateWorkSchedules',
  DeleteWorkSchedules = 'DeleteWorkSchedules',
  DeleteWorkBreaks = 'DeleteWorkBreaks',
  DeleteWorkSchedulesByPeriod = 'DeleteWorkSchedulesByPeriod',
  GetWorkScheduleById = 'GetWorkScheduleById',
  GetEmployeeWorkSchedules = 'GetEmployeeWorkSchedules',
  GetEmployeesWorkSchedules = 'GetEmployeesWorkSchedules',
  GetEmployeesWorkSchedulesByUserIds = 'GetEmployeesWorkSchedulesByUserIds',
  GetWorkScheduleByIds = 'GetWorkScheduleByIds',
  GetEmployeesWithoutWorkSchedule = 'GetEmployeesWithoutWorkSchedule',
  GetEmployeeWorkScheduleForDate = 'GetEmployeeWorkScheduleForDate',
  CheckEmployeeWorkSchedule = 'CheckEmployeeWorkSchedule',
  CheckEmployeeWorkBreak = 'CheckEmployeeWorkBreak',
  DeleteEmployeeWorkScheduleForDate = 'DeleteEmployeeWorkScheduleForDate',
}

export interface ModelWorkSchedule {
  Id: number;
  UserId: number;
  BranchId: number;
  TimeS: string;
  TimeE: string;
  IsIgnoreRecords: boolean;
}

export interface ModelWorkBreak {
  Id: number;
  UserId: number;
  BranchId: number;
  TimeS: string;
  TimeE: string;
}

export interface ModelWorkScheduleDeletion {
  UserIds?: number[] | null;
  BranchId: number;
  DateS: string;
  DateE: string;
}

export interface ModelEmployeeWorkSchedules {
  UserId: number;
  UserName?: string | null;
  DateS: string;
  DateE: string;
  WorkSchedules?: ModelWorkSchedule[] | null;
}

export interface ModelEmployeeDateWorkSchedule {
  UserId: number;
  NameFirst?: string | null;
  NameLast?: string | null;
  Date: string;
  WorkSchedule: ModelWorkSchedule;
  WarningForEdit?: string | null;
  WarningForDelete?: string | null;
  BranchWorkTime: ModelBranchWorkTime;
}

export interface ModelCheckEmployeeWorkSchedule {
  UserId: number;
  NameFirst?: string | null;
  NameLast?: string | null;
  WarningForEdit?: string | null;
  WarningForDelete?: string | null;
}

export interface ModelCheckEmployeeWorkBreak {
  UserId: number;
  NameFirst?: string | null;
  NameLast?: string | null;
  WarningForEdit?: string | null;
}

export interface ModelJournalEmployee {
  Id: number;
  NameLast?: string | null;
  NameFirst?: string | null;
  NameMiddle?: string | null;
  NameFull?: string | null;
  Photo?: string | null;
  PositionId?: number | null;
  Position?: string | null;
  WorkTimeS?: string | null;
  WorkTimeE?: string | null;
}

export type UpdateWorkScheduleRequest = WithActiveBranchId<{
  data: ModelWorkSchedule;
}>;

export type UpdateWorkBreakRequest = WithActiveBranchId<{
  data: ModelWorkBreak;
}>;

export type UpdateWorkSchedulesRequest = WithActiveBranchId<{
  data: ModelWorkSchedule[];
}>;

export type DeleteWorkSchedulesRequest = WithActiveBranchId<{
  data: number[];
}>;

export type DeleteWorkBreaksRequest = WithActiveBranchId<{
  data: number[];
}>;

export type DeleteWorkSchedulesByPeriodRequest = WithActiveBranchId<{
  data: ModelWorkScheduleDeletion;
}>;

export type GetWorkScheduleByIdRequest = WithActiveBranchId<{
  scheduleId: number;
}>;

export type GetEmployeeWorkSchedulesRequest = WithActiveBranchId<{
  forUserId: number;
  branchId: number;
  dateS: string;
  dateE: string;
}>;

export type GetEmployeesWorkSchedulesRequest = WithActiveBranchId<{
  branchId: number;
  dateS: string;
  dateE: string;
  data: number[];
}>;

export type GetEmployeesWorkSchedulesByUserIdsRequest = WithActiveBranchId<{
  branchId: number;
  dateS: string;
  dateE: string;
  data: number[];
}>;

export type GetWorkScheduleByIdsRequest = WithActiveBranchId<{
  data: number[];
}>;

export type GetEmployeesWithoutWorkScheduleRequest = WithActiveBranchId<{
  date: string;
}>;

export type GetEmployeeWorkScheduleForDateRequest = WithActiveBranchId<{
  employeeId: number;
  date: string;
}>;

export type CheckEmployeeWorkScheduleRequest = WithActiveBranchId<{
  employeeId: number;
  timeS: string;
  timeE: string;
}>;

export type CheckEmployeeWorkBreakRequest = WithActiveBranchId<{
  employeeId: number;
  timeS: string;
  timeE: string;
}>;

export type DeleteEmployeeWorkScheduleForDateRequest = WithActiveBranchId<{
  employeeId: number;
  date: string;
}>;

export type UpdateWorkScheduleResponse = ModelWorkSchedule;
export type UpdateWorkBreakResponse = ModelWorkBreak;
export type UpdateWorkSchedulesResponse = ModelWorkSchedule[];
export type DeleteWorkSchedulesResponse = void;
export type DeleteWorkBreaksResponse = void;
export type DeleteWorkSchedulesByPeriodResponse = void;
export type GetWorkScheduleByIdResponse = ModelWorkSchedule;
export type GetEmployeeWorkSchedulesResponse = ModelEmployeeWorkSchedules;
export type GetEmployeesWorkSchedulesResponse = ModelEmployeeWorkSchedules[];
export type GetEmployeesWorkSchedulesByUserIdsResponse =
  ModelEmployeeWorkSchedules[];
export type GetWorkScheduleByIdsResponse = ModelWorkSchedule[];
export type GetEmployeesWithoutWorkScheduleResponse = ModelJournalEmployee[];
export type GetEmployeeWorkScheduleForDateResponse =
  ModelEmployeeDateWorkSchedule;
export type CheckEmployeeWorkScheduleResponse = ModelCheckEmployeeWorkSchedule;
export type CheckEmployeeWorkBreakResponse = ModelCheckEmployeeWorkBreak;
export type DeleteEmployeeWorkScheduleForDateResponse = void;
